import { acceptAll, acceptRequired, getSettings, settingsComplete } from "../lib/cookie-consent";
import { getString } from "../lib/localization";

class CookieDialog extends HTMLElement {

   constructor() {
      super();

      this.classList.add("cookie-dialog");

      window.addEventListener("load", () => {
         if (!settingsComplete()) {
            this.show();
         }
      });

      const box = document.createElement("div");
      box.className = "cookie-dialog__box";
      this.appendChild(box);

      const title = document.createElement("div");
      title.className = "headline-7 text-primary";
      title.innerText = getString("cookieDialog.title");
      box.appendChild(title);

      const text = document.createElement("p");
      text.className = "mt-3 mb-1";
      text.innerHTML = getString("cookieDialog.text");
      box.appendChild(text);

      const toolbar = document.createElement("div");
      toolbar.className = "toolbar";
      box.appendChild(toolbar);

      const acceptAllButton = document.createElement("button");
      acceptAllButton.className = "button button--primary mt-3";
      acceptAllButton.innerText = getString("cookieDialog.acceptAll");
      acceptAllButton.addEventListener("click", () => {
         acceptAll();
         this.hide();
      });
      toolbar.appendChild(acceptAllButton);

      const acceptRequiredButton = document.createElement("button");
      acceptRequiredButton.className = "button button--outline-primary mt-3";
      acceptRequiredButton.innerText = getString("cookieDialog.acceptRequired");
      acceptRequiredButton.addEventListener("click", () => {
         acceptRequired();
         this.hide();
      });
      toolbar.appendChild(acceptRequiredButton);
   }

   show() {
      this.classList.add("is-visible");
      document.body.classList.add("has-cookie-dialog");
   }

   hide() {
      document.body.classList.remove("has-cookie-dialog");
      this.classList.remove("is-visible");
   }

}

customElements.define('cookie-dialog', CookieDialog);
